import React from 'react'
import cls from 'classnames'
import styles from './NoData.module.scss'
import { useLocale } from 'core/components/Locale'
import { Flex } from 'antd'

interface NoDataProps {
  text?: string
  text_sub?: string
  small?: boolean
  fixedDarkTheme?: boolean //固定为黑版样式，用于某些模块头部
  className?: string
}

const NoData: React.FC<NoDataProps> = ({
  text = 'contractOrder_029',
  text_sub = '',
  small = false,
  fixedDarkTheme = false,
  className,
}) => {
  // const style = useSelector((state: any) => state.settings.style)

  const t = useLocale()

  return (
    <Flex
      vertical
      gap={12}
      align="center"
      className={cls('hc_empty', styles['noData'], className, { [styles.fixedDarkTheme]: fixedDarkTheme })}
    >
      <div className={styles.imgBox}></div>
      <div className="c16 font-normal f12">
        <div className="text-center">{t(text)}</div>
        {text_sub && <div className={cls(styles.text, styles.textSub, 'color-wb16')}>{t(text_sub)}</div>}
      </div>
    </Flex>
  )
}

export default NoData
